import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import laptop from "../../../assets/laptop.png";

const statsData = [
  { label: "Influencers Database", value: 2000 },
  { label: "Ready to work on ACPV", value: 500 },
  { label: "Brands Engaged", value: 25 },
  { label: "In Discussion", value: 11 },
];

const AnimatedCounter = ({ target }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 1000;
    const stepTime = duration / target;
    const timer = setInterval(() => {
      start += 5;
      setCount(start > target ? target : start);
      if (start >= target) clearInterval(timer);
    }, stepTime);
    return () => clearInterval(timer);
  }, [target]);

  return <span className="text-3xl font-bold">{count}+</span>;
};

const statVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.15, type: "spring", stiffness: 80 }
  }),
};

const imageVariants = {
  hidden: { opacity: 0, rotate: -10, x: 80 },
  visible: { opacity: 1, rotate: 0, x: 0, transition: { type: "spring", stiffness: 60, delay: 0.5 } },
  hover: { scale: 1.05, rotate: 2, transition: { type: "spring", stiffness: 200 } }
};

const Reporting = () => {
  return (
    <div
      className="flex md:flex-row flex-col items-center justify-center md:py-6 md:px-20 px-4 bg-white"
      style={{ fontFamily: "Gilroy-Medium" }}
    >
      {/* Left: Stats */}
      <motion.div
        className="grid grid-cols-2 gap-6 md:w-1/2 w-full  p-6"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        {statsData.map((item, idx) => (
          <motion.div
            key={idx}
            className="bg-white rounded-lg shadow-md p-6 text-center border-2 border-gray-300 hover:shadow-lg transition-shadow duration-300 hover:-translate-y-2"
            variants={statVariants}
            custom={idx}
            whileHover={{ scale: 1.04, boxShadow: "0 8px 32px rgba(0,0,0,0.12)" }}
          >
            <AnimatedCounter target={item.value} />
            <p className="mt-2 text-gray-600 text-sm md:text-base">{item.label}</p>
          </motion.div>
        ))}
      </motion.div>

      {/* Right: Animated Laptop Image */}
      <div className="md:w-1/2 w-full flex justify-center items-center mt-3 md:mt-0 ">
        <motion.div
          className="relative flex items-center justify-center w-full"
          initial="hidden"
          whileInView="visible"
          whileHover="hover"
          variants={imageVariants}
          viewport={{ once: true, amount: 0.3 }}
          style={{ justifyContent: "center" }}
        >
          <img
            src={laptop}
            alt="Laptop Reporting"
            className="mx-auto w-[220px] sm:w-[300px] lg:w-[450px] transition-transform duration-500"
            style={{ maxWidth: "60vw" }}
          />
        </motion.div>
      </div>
    </div>
  );
};

export default Reporting;
